/**
 * HTML转义
 * @param {String} html HTML代码
 */
export const htmlEncode = (html) => {
    // <  -> &lt;
    html = html + '';
    return html.replace(/[<>&"]/g, (res) => {
        return {
            '<': '&lt;',
            '>': '&gt;',
            ' ': '&nbsp;',
            '&': '&amp;',
            '"': '&quot;',
        }[res];
    });
};
/**
 * HTML反转义
 * @param {String} html HTML代码
 */
export const htmlDecode = (html) => {
    // &lt; -> <
    html = html + '';
    const arrEntities = {
        lt: '<',
        gt: '>',
        nbsp: ' ',
        amp: '&',
        quot: '"',
    };
    return html.replace(/&(lt|gt|nbsp|amp|quot);/gi, (all, t) => {
        return arrEntities[t];
    });
};
